﻿export default class ApplicationsSessionLog {
	constructor(init) {
		this.sessionTimestamp = null;
		this.ipv4Address = null;
		this.os = null;
		this.device = null;
		this.brand = null;
		this.model = null;
		this.agreedTerms = [];

		if (init) {
			this.sessionTimestamp = init.sessionTimestamp;
			this.ipv4Address = init.ipv4Address;
			this.os = init.os;
			this.device = init.device;
			this.brand = init.brand;
			this.model = init.model;
			this.agreedTerms = init.agreedTerms;
		}
	}
}
